<template>
    <app-layout title="Status webhooks webshops">
        <template #header>
            <page-title title="Status webhooks webshops" />
        </template>

        <template #pageContent>
            <Table class="w-1/3">
                <thead>
                    <Th>Webshop</Th>
                    <Th>Status webhook</Th>
                </thead>
                <tbody>
                    <tr v-for="webshop in webshops">
                        <Td>
                            {{ webshop.name }}
                        </Td>
                        <Td>
                            {{ webhooks[webshop.code] }}
                        </Td>
                    </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import store from '@/store'
export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
    },
    props: [
        'webshops',
        'webhooks',
    ],
    setup (props){


        return {
            state: store.state,
            ...store,
        }
    },
}

</script>
